import * as Sentry from "@sentry/nextjs";

/**
 * Names the signed-in person as the Sentry user for the rest of the request, by their Nowadays
 * user id only (no email), so a server error shows who hit it instead of the proxy IP. Does
 * nothing in the browser: `getCurrentUser` also runs in client components, and this is for
 * server errors only.
 *
 * @param userId - The person's `nowadays.users.user_id`.
 * @returns Nothing.
 */
export function setSentryUser(userId: number): void {
  if (typeof window !== "undefined") return;
  Sentry.setUser({ id: String(userId) });
}

/**
 * The Nowadays user id the current request named with {@link setSentryUser}, if any.
 *
 * @returns The user id, or null when nobody signed in has been resolved this request.
 */
export function getSentryUserId(): number | null {
  const id = Number(Sentry.getIsolationScope().getUser()?.id);
  return Number.isInteger(id) && id > 0 ? id : null;
}
